module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmYS1zb2xpZC05MDAuc3ZnIjs="


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.svg
// module id = 30
// module chunks = 0